import hideZeroPriceSizesInCurrentColor from './hideZeroPriceSizesInCurrentColor';
import updateSelectedVariant from './updateSelectedVariant';
import hideSoldOutClearanceColors from './hideSoldOutClearanceColors';
import hideZeroPriceColors from './hideZeroPriceColors';
import getSelectedVariant from './getSelectedVariant';
import {
  getProductJson,
  getProductType,
  getProductPrices,
  getProductInventories,
  getProductStyleNumbers,
  getProductClearances,
} from '../../core/productInfo';
import adMindDetails from '../AdMind/detail';
import { ProductOverview } from '../../sections/INF-ProductOverview';

let eventsBinded = false;

let Shopify = window.Shopify || {};

const ProductOptions = () => {
  const productJson = getProductJson();
  const productType = getProductType();
  const productPrices = getProductPrices();
  const productInventories = getProductInventories();
  const productStyleNumbers = getProductStyleNumbers();
  const productClearances = getProductClearances();

  // Return if unable to parse the product data
  if (!productJson || !productInventories || !productClearances) {
    return;
  }

  document.querySelectorAll('[data-color-variant-selector]').forEach((el) => {
    const styleNumber = productStyleNumbers[el.getAttribute('data-value')];
    const givexBg = styleNumber
      ? `https://cdn.shopify.com/s/files/1/0070/8853/7651/t/8/assets/${styleNumber}_GCS_48x48_crop_center.jpg?v=${window.theme.swatches_updated_at}`
      : '';
    const regBg = styleNumber
      ? `https://cdn.shopify.com/s/files/1/0070/8853/7651/t/8/assets/${styleNumber}_SWT_48x48_crop_center.jpg?v=${window.theme.swatches_updated_at}`
      : '';

    const bgImgUrl = productType.startsWith('GIVEX') ? givexBg : regBg;

    el.style.backgroundImage = `url(${bgImgUrl})`;
  });

  // If selected variant is 0 price
  // Select the first available variant, which will run this function again
  const selectedVariant = getSelectedVariant(productJson);
  if (selectedVariant && selectedVariant.price === 0) {
    let firstAvailableVariant;
    for (let variant of productJson.variants) {
      if (variant.price > 0) {
        firstAvailableVariant = variant;
        break;
      }
    }

    if (firstAvailableVariant) {
      document.querySelector(`[data-color-variant-selector][data-value="${firstAvailableVariant.option1}"]`).click();
      document.querySelector(`[data-size-variant-selector][data-value="${firstAvailableVariant.option2}"]`).click();
    }
  }

  const init = () => {
    const initialVariant = getSelectedVariant(productJson);
    const firstTimeLoading = true;
    if (window.Shopify.currency.active == 'USD') {
      updateSelectedVariant(initialVariant, productInventories, productJson, firstTimeLoading);
    }

    hideSoldOutClearanceColors(productJson, productInventories, productClearances);
    hideZeroPriceColors(productJson, productPrices);
    hideZeroPriceSizesInCurrentColor();
  };

  if (!eventsBinded) {
    document.addEventListener('selectedProductDidUpdate', (e) => {
      const variant = e.detail.variant;
      const container = e.detail.container;
      // Get the selected option by customer, this should have been set up previously
      const option = window.optionClicked;

      let product_json = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
      let inventory_json = productInventories;

      if (window.inventory980) {
        inventory_json = window.inventory980.color;
      }

      updateSelectedVariant(variant, inventory_json, product_json, false, option);

      // Yield these code executions to the end of the queue
      // they aren't user-visible tasks and can be deferred
      setTimeout(() => {
        hideZeroPriceSizesInCurrentColor();

        // provide a fair product_detail object to Admind
        const productDetail = {
          product: product_json,
          currentVariant: variant,
          container,
        };

        adMindDetails(productDetail);
      }, 0);
    });

    // handle clicking on the mobile sticky buy options
    // by passing the event to the primary click
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-secondary-color-variant-selector]')) {
        const val = e.target.getAttribute('data-value');
        document.querySelector(`[data-color-variant-selector][data-value="${val}"]`).click();
      }
      if (e.target.matches('[data-secondary-size-variant-selector]')) {
        const val = e.target.getAttribute('data-value');
        document.querySelector(`[data-size-variant-selector][data-value="${val}"]`).click();
      }
    });

    eventsBinded = true;
  }

  var variants = document.querySelectorAll('.variant-custom-fields');
  var form = document.querySelector('form[action="/cart/add"]');

  // Set the active variant on page load.
  form.addEventListener('change', () => {
    setActiveVariantCustomFields(form, variants);
  });

  /**
   * Sets the active variant based on the "id" select dropdown in the add to cart form.
   */
  function setActiveVariantCustomFields(form, variants) {
    variants.forEach((variant) => (variant.style.display = 'none'));
    setTimeout(() => {
      const selectedVariantID = getSelectedVariant(productJson);
      const dataVariantId = document.querySelector(`[data-variant-id="${selectedVariantID.id}"]`);
      if (dataVariantId) {
        dataVariantId.style.display = 'block';
      }
    }, 100);
  }

  init();
};

document.addEventListener('quickViewDidLoad', () => {
  ProductOptions();
  ProductOverview();
  // update quickview wishlist text, hacky way since plugin won't allow you to style the same as PDP
  setTimeout(() => {
    const quickviewWishlist = document.querySelector('[data-quickview-wishlist]');
    if (quickviewWishlist) {
      let quickviewWishlistText = quickviewWishlist.getAttribute('aria-label');
      document.querySelector('[data-quickview-wishlist-text]').textContent = quickviewWishlistText;
    }
  }, 500);

  try {
    Shopify.PaymentButton.init();
  } catch (error) {
    console.log('error:', error);
  }
});

export default ProductOptions;
